export default __webpack_public_path__ + "static/media/pic_product_02.def101ab.jpg";